import { Node } from '@tiptap/core';

/**
 * Sections survive the editor.
 *
 * Generated documents declare their own pages as <section class="cara-page">, and full-bleed
 * covers and closings as <section class="cara-page cover">. Without a node for it the schema
 * drops the wrapper on load and the document is saved back without it, so opening a document
 * would silently destroy the pagination and the full-bleed pages the generator produced.
 */
export const SectionNode = Node.create({
  name: 'section',

  group: 'block',
  content: 'block*',

  parseHTML() {
    return [{ tag: 'section' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['section', HTMLAttributes, 0];
  }
});
